import React from 'react'
import clsx from 'clsx'
import { SvgIcon } from '@mui/material'
import { Color } from 'src/AppTypes'
import { ReactComponent as EllipseIcon } from './assets/ellipse.svg'
import style from './styles.module.scss'

export type EllipseProps = {
  color: Color
} & React.StyledProps

export const Ellipse: React.StyledFC<EllipseProps> = ({
  color,
  className,
}: EllipseProps) => {
  return (
    <SvgIcon
      component={EllipseIcon}
      className={clsx(className, style.root, style[color])}
      viewBox="0 0 8 8"
    />
  )
}
